import { Component } from '@angular/core';
import { IndexComponent } from '../../components/index/index.component';
import { PromotionsComponent } from '../../sections/promotions/promotions.component';
import { PlansServiceComponent } from '../../sections/plans-service/plans-service.component';
import { HeaderComponent } from '../../components/header/header.component';
@Component({
  selector: 'app-services',
  standalone: true,
  imports: [IndexComponent,PromotionsComponent,PlansServiceComponent,HeaderComponent],
  templateUrl: './services.component.html',
  styleUrl: './services.component.scss'
})
export class ServicesComponent {

}
